import type { CustomCellRendererProps } from 'ag-grid-react';
import { Check } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { SavingsListQuery } from '@/generated/gql/graphql';

type SavingsListRow = SavingsListQuery['savings'][number];

export const MultiYearSavingCellRenderer = ({ value }: CustomCellRendererProps<SavingsListRow, boolean>) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'Savings.dataGrid.column' });

  if (!value) return null;

  return (
    <span className="flex items-center" aria-label={t('multiYearSaving')}>
      <Check className="size-4" />
    </span>
  );
};
